module.exports = __webpack_public_path__ + "img/72.5ea7ce13.jpg";